import React from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";

const DateInput = (props: any) => {
  const {
    placeholder,
    value,
    register,
    type = "datetime-local", // default to date+time
    errors,
    label,
    min = null,
    disabled = false,
  } = props;

  // Format date to "YYYY-MM-DDTHH:MM"
  const formatDateTimeForInput = (dateString: string) => {
    const date = new Date(dateString);
    const offset = date.getTimezoneOffset();
    const localDate = new Date(date.getTime() - offset * 60 * 1000);
    return localDate.toISOString().slice(0, 16);
  };

  const now = formatDateTimeForInput(new Date().toISOString());

  return (
    <div className={tw`w-full my-2 text-left mt-2`}>
      <label>{label}</label>
      <input
        placeholder={placeholder}
        defaultValue={value ? formatDateTimeForInput(value) : ""}
        disabled={disabled}
        {...register}
        type={type}
        min={min ? formatDateTimeForInput(min) : undefined}
        max={now}
        className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
      />
      {errors && (
        <p className={tw`text-red-500 text-xs my-1`}>{errors?.message}</p>
      )}
    </div>
  );
};

export default DateInput;
